import firebase from "src/Firebase"
import moment from "moment"
import axios from "src/utils/axios"

const db = firebase.firestore()
const ARCHIVE_PUBLIC_URL = "https://micasitaarchivo.s3.amazonaws.com/"

const maintenanceRef = idcollection =>
  db.collection("conjuntos").doc(idcollection).collection("mantenimientos")

export const getMantenimientos = (idconjunto, observer) =>
  maintenanceRef(idconjunto)
    .where("rrule.until", ">=", moment().startOf("year").toDate())
    .onSnapshot(observer)

export const addMantenimiento = (idconjunto, data) =>
  maintenanceRef(idconjunto).add(data)

export const updateMantenimiento = (idconjunto, idmant, data) =>
  maintenanceRef(idconjunto).doc(idmant).update(data)

export const deleteMantenimiento = (idconjunto, idmant) =>
  maintenanceRef(idconjunto).doc(idmant).delete()

export const saveFiles = async (file, idconjunto) => {
  try {
    const form = new FormData()
    form.append("prefix", `${idconjunto}/adjuntos/mantenimientos/`)
    form.append("files", file)

    const response = await axios.post("archive/upload", form, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Content-size": file.size,
      },
    })
    const key = response?.data?.[0]?.Key
    if (!key) throw new Error("No se recibió la ruta del archivo subido")

    return `${ARCHIVE_PUBLIC_URL}${key}`
  } catch (error) {
    throw Error("Error al subir archivo")
  }
}

export const deleteMaintenanceFile = async (url, idconjunto) => {
  const key = decodeURIComponent(new URL(url).pathname.slice(1))
  const expectedPrefix = `${idconjunto}/adjuntos/mantenimientos/`
  if (!key.startsWith(expectedPrefix)) return

  await axios.delete("archive/upload", { data: { files: [key] } })
}

// legacy code mantenimientos
export const suscriberPendingMaintenances = (observer, idConjunto) =>
  maintenanceRef(idConjunto)
    .where("ManFuturo", "<=", moment().format("yyyy-MM-DD"))
    .orderBy("ManFuturo", "asc")
    .onSnapshot(observer)
